window.addEventListener("load", function(){
    let ua = navigator.userAgent;
    if(ua.indexOf("GlazeroWebView") >= 0){
        handleFormEvent();
    }
});
function handleFormEvent(){
    const formControls = document.querySelectorAll(".form-control");
    for(let i=0; i<formControls.length; i++){
        const formControl = formControls[i];
        const inputs = formControl.querySelectorAll(".input.is-floating");
        const selectContainers = formControl.querySelectorAll(".select-container");
        if(inputs && inputs.length>0){
            const input = inputs[0];
            if(input.id){
                const labels = formControl.querySelectorAll("label[for=" + input.id + "]");
                if(labels && labels.length>0){
                    const label = labels[0];
                    if(input.value){
                        label.classList.add("transform-label");
                    }
                    input.onfocus = () => {
                        label.classList.add("transform-label");
                        if(selectContainers && selectContainers.length>0){
                            selectContainers[0].classList.add("select-focus");
                        }
                    }
                    input.onblur = () => {
                        if(!input.value){
                            label.classList.remove("transform-label");
                        }
                        if(selectContainers && selectContainers.length>0){
                            selectContainers[0].classList.remove("select-focus");
                        }
                    }
                }
            }
        }
    }
}

window.goToUrl = function(url,title){
  setTitleText(title);
  window.location.href = url;
}

window.isNewVerion = function(){
  //if(!window.glVersion){
    let ua = navigator.userAgent;
    let glVersion = ua.substr(ua.indexOf("GlazeroWebView") + 15,5);
    glVersion = parseFloat(glVersion.replaceAll(".",""));
    window.glVersion = glVersion >= 700 ? true : false;
  //}
  return window.glVersion;
}

window.getUrlParams = (key) => {
    let reg = new RegExp("(^|&)" + key + "=([^&]*)(&|$)");
    let r = window.location.search.substr(1)
        .match(reg);
    if (r != null)
        //return unescape(r[2]);
        return decodeURI(r[2]);
    return null;
}
window.checkOutHandler = (storefrontToken, cartId, failCallback) => {
    getCheckoutUrl(storefrontToken, cartId, result=>{
        if(result && result.data && result.data.cart && result.data.cart.checkoutUrl){
            window.location.href = result.data.cart.checkoutUrl;
        }else{
            failCallback(JSON.stringify(result));
        }
    }, failCallback);
}

//{"seq": [{"name":"StorefrontToken", "required": true, "errMsg": ""}], "successCallback": Func}
window.loadEnvSeq = (param) => {
    window.env = param;
    window.curEnvIndex = 0;
    doLoad();
}

window.doLoad = () => {
    try{
        if(window.env.seq.length<=0){
            return;
        }
        if(window.curEnvIndex >= window.env.seq.length){
            if(window.env["successCallback"]){
                window.env["successCallback"]();
            }
            return;
        }
        let curEnv = window.env.seq[window.curEnvIndex];
        if("StorefrontToken" === curEnv.name){
            getStorefrontToken("getStorefrontTokenCallbackInGlobal");
        }else if("GetAccessToken" === curEnv.name){
            getContentFromApp("accessToken", "getAccessTokenCallbackInGlobal");
        }else if("GetAccountInfo" === curEnv.name){
            getAccountInfo("getAccountInfoCallbackInGlobal")
        }else if("GetCartId" === curEnv.name){
            getContentFromApp("cart", "getCartIdInGlobal");
        }else if("GetCart" === curEnv.name){
            if(window.storefrontToken && window.cartId){
                getCart(window.storefrontToken, window.cartId, getCartSuccessCallbackInGlobal, getCartFailCallbackInGlobal);
            }else{
                setCartNumInHeader(0);
                if(window.env.seq[window.curEnvIndex]["required"]){
                    writeLog("error", "[global.js -> doLoad]: " + window.env.seq[window.curEnvIndex]["errMsg"]);
                }else{
                    setDiscountCodeCopied(false);
                    window.curEnvIndex++;
                    doLoad();
                }
            }
        }
    }catch(err){
        writeLog("error", "[global.js -> doLoad]: " + err);
    }
}

window.getStorefrontTokenCallbackInGlobal = (url, data) => {
    const dataObj = eval("(" + data + ")");
    if(dataObj && dataObj.code===0 && dataObj.data && dataObj.data.storefrontToken!==""){
        window.storefrontToken = dataObj.data.storefrontToken;
        window.curEnvIndex++;
        doLoad();
    }else{
        if(window.env.seq[window.curEnvIndex]["required"]){
            writeLog("error", "[global.js -> getStorefrontTokenCallbackInGlobal]: " + window.env.seq[window.curEnvIndex]["errMsg"]);
        }else{
            window.curEnvIndex++;
            doLoad();
        }
    }
}

window.getAccessTokenCallbackInGlobal = (url, data) => {
    const dataObj = eval("(" + data + ")");
    if(dataObj && dataObj.code===0 && dataObj.data && dataObj.data.value!==""){
        window.accessToken = dataObj.data.value;
        window.curEnvIndex++;
        doLoad();
    }else{
        if(window.env.seq[window.curEnvIndex]["required"]){
            writeLog("error", "[global.js -> getAccessTokenCallbackInGlobal]: " + window.env.seq[window.curEnvIndex]["errMsg"]);
        }else{
            window.curEnvIndex++;
            doLoad();
        }
    }
}

window.getAccountInfoCallbackInGlobal = (url, data) => {
    const dataObj = eval("(" + data + ")");
    if(dataObj && dataObj.code===0 && dataObj.data){
        window.curEmail = dataObj.data.email;
        window.curRegion = dataObj.data.region;
        document.getElementById("verifyEmail").value = dataObj.data.email;
        window.curEnvIndex++;
        doLoad();
    }else{
        if(window.env.seq[window.curEnvIndex]["required"]){
            writeLog("error", "[global.js -> getAccountInfoCallbackInGlobal]: " + window.env.seq[window.curEnvIndex]["errMsg"]);
        }else{
            window.curEnvIndex++;
            doLoad();
        }
    }
}

window.getCartIdInGlobal = (url, data) => {
    const dataObj = eval("(" + data + ")");
    if(dataObj && dataObj.code===0 && dataObj.data && dataObj.data.value!==""){
        window.cartId = dataObj.data.value;
        window.curEnvIndex++;
        doLoad();
    }else{
        setCartNumInHeader(0);
        if(window.env.seq[window.curEnvIndex]["required"]){
            writeLog("error", "[global.js -> getCartIdInGlobal]: " + window.env.seq[window.curEnvIndex]["errMsg"]);
        }else{
            window.curEnvIndex++;
            doLoad();
        }
    }
}

window.getCartSuccessCallbackInGlobal = (cartData) => {
    if(cartData){
        if(cartData.data.cart){
            window.cart = cartData;
            if(cartData.data.cart.lines.edges.length > 0){
                setCartNumInHeader(cartData.data.cart.totalQuantity);
            }else {
                setCartNumInHeader(0);
            }
            if(cartData.data.cart.discountCodes.length > 0){
                setDiscountCodeCopied(true);
            }else{
                setDiscountCodeCopied(false);
            }
        }else{
            setCartNumInHeader(0);
            window.cartId = null;
            setDiscountCodeCopied(false);
        }
        window.curEnvIndex++;
        doLoad();
    }else{
        setCartNumInHeader(0);
        if(window.env.seq[window.curEnvIndex]["required"]){
            writeLog("error", "[global.js -> getCartSuccessCallbackInGlobal]: " + window.env.seq[window.curEnvIndex]["errMsg"]);
        }else{
            setDiscountCodeCopied(false);
            window.curEnvIndex++;
            doLoad();
        }
    }
}

window.getCartFailCallbackInGlobal = (error) => {
    if(window.env.seq[window.curEnvIndex]["required"]){
        writeLog("error", "[global.js -> getCartFailCallbackInGlobal]: " + window.env.seq[window.curEnvIndex]["errMsg"]+ ", real error: " + error);
    }else{
        setDiscountCodeCopied(false);
        window.curEnvIndex++;
        doLoad();
    }
}

window.setCartNumInHeader = (num) => {
    //if(isNewVerion()){
      setContent2App("ShoppingCartCount",num);
    //}
    let carNumInHeader = document.getElementById("carNumInHeader");
    carNumInHeader.innerText = num;
    if(num > 0){
        carNumInHeader.classList.remove("cart-num-hidden");
    }else{
        carNumInHeader.classList.add("cart-num-hidden");
    }
}

window.convertUTCTimeToLocalTime = (UTCDateString,containHMN) => {
    if(!UTCDateString){
      return '-';
    }
    function formatFunc(str) {
      return str > 9 ? str : '0' + str
    }
    var date2 = new Date(UTCDateString); 
    var year = date2.getFullYear();
    var mon = formatFunc(date2.getMonth() + 1);
    var day = formatFunc(date2.getDate());
    var hour = date2.getHours();
    var noon = hour >= 12 ? 'pm' : 'am';
    hour = hour>=12?hour-12:hour;
    hour = formatFunc(hour);
    var min = formatFunc(date2.getMinutes());
    const monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    if(containHMN){
        return monthNames[mon-1]+' '+day+','+year+" at "+hour+':'+min+" "+noon;
    }else{
        return monthNames[mon-1]+' '+day+','+year;
    }
}

window.convertUTCTimeToLocalTime1 = (UTCDateString) => {
    if(!UTCDateString){
      return '-';
    }
    function formatFunc(str) {
      return str > 9 ? str : '0' + str
    }
    var date2 = new Date(UTCDateString); 
    var year = date2.getFullYear();
    var mon = formatFunc(date2.getMonth() + 1);
    var day = formatFunc(date2.getDate());
    var hour = date2.getHours();
    var noon = hour >= 12 ? 'pm' : 'am';
    hour = hour>=12?hour-12:hour;
    hour = formatFunc(hour);
    var min = formatFunc(date2.getMinutes());
    return year + "-" + mon + "-" + day + " " + hour + ':' + min;
}

window.startBtnLoading = (btnId) => {
    let btn = document.getElementById(btnId);
    let div = btn.querySelector("#" + btnId + " > div");
    div.style.opacity = 0;
    const loaderSpan = btn.querySelector("#" + btnId + " > span");;
    loaderSpan.style.opacity = 1;
    let spanChildren = loaderSpan.querySelectorAll("span");
    if(spanChildren && spanChildren.length>0){
        for(let i=0;i<spanChildren.length;i++){
            spanChildren[i].classList.add("loader-item"+(i+1));
        }
    }
}

window.endBtnLoading = (btnId) => {
    let btn = document.getElementById(btnId);
    let div = btn.querySelector("#" + btnId + " > div");
    div.style.opacity = 1;
    const loaderSpan = btn.querySelector("#" + btnId + " > span");
    loaderSpan.style.opacity = 0;
    let spanChildren = loaderSpan.querySelectorAll("span");
    if(spanChildren && spanChildren.length>0){
        for(let i=0;i<spanChildren.length;i++){
            spanChildren[i].removeAttribute("class");
        }
    }
}

window.showPageLoading = () => {
    document.getElementById("pageLoading").style.display = "block";
}

window.hidePageLoading = () => {
    document.getElementById("pageLoading").style.display = "none";
}

window.setDiscountCodeCopied = (val) => {
    window.discountCopied = val;
}

window.getEnvCallbackInGlobal = (data,result) => {
    try {
      writeLog("info", '请求Env回调getEnvCallbackInGlobal');
      writeLog("info", '请求Env信息data:'+JSON.stringify(data));
      writeLog("info", '请求Env信息result:'+JSON.stringify(result));
    }catch(err) {}
  
    if(result){
      /*writeLog("info", '请求getHeaders');*/
      window.apiNetHost = JSON.parse(result).data.netHost;
      if(window.apiNetHost){
        localStorage.setItem('ApiDomain',window.apiNetHost);
        /*writeLog("info", '设置缓存ApiDomain:'+window.apiNetHost);*/
      }else if(localStorage.getItem('ApiDomain')){
        window.apiNetHost = localStorage.getItem('ApiDomain');
      }
      /*writeLog("info", '设置window.netHost:'+window.apiNetHost);*/
      getHeaders("getHeaderCallbackInGlobal");
    }
}

window.roundFloat = (str) => {
  return Math.floor(str * 100) / 100;
}


window.setLocalization = function(localization){
  setContent2App("h5_customCountryCode",localization);
  localStorage.setItem('h5_customCountryCode', localization);
  setCookie("h5_customCountryCode",localization,365);
}

window.getLocalization = function(){
  let country = localStorage.getItem('h5_customCountryCode');
  if(country){
    return country;
  }else{
    country = getCookie("h5_customCountryCode");
    if(country != null){
      return country;
    }
  }
  return "US";
}

window.getCurrencyCode = function(countryCode){
    let countryCurrency = [
        {"name":"USD","symbol":"$"},
        {"name":"PLN","symbol":"zł"},
        {"name":"AUD","symbol":"$"},
        {"name":"CAD","symbol":"$"},
        {"name":"EUR","symbol":"€"},
        {"name":"CNY","symbol":"¥"},
        {"name":"GBP","symbol":"£"}
    ];

    var result = countryCurrency.filter(item => item.name === countryCode);
    if(result.length > 0){
        return result[0].symbol;
    }
    return "$";
}

function setCookie(name, value, days) {
  var domain, domainParts, date, expires, host;

  if (days)
  {
    date = new Date();
    date.setTime(date.getTime()+(days*24*60*60*1000));
    expires = "; expires="+date.toGMTString();
  }
  else
  {
    expires = "";
  }

  host = location.host;
  if (host.split('.').length === 1)
  {
    document.cookie = name+"="+value+expires+"; path=/";
  }
  else
  {
    domainParts = host.split('.');
    domainParts.shift();
    domain = '.'+domainParts.join('.');

    document.cookie = name+"="+value+expires+"; path=/; domain="+domain;
    if (getCookie(name) == null || getCookie(name) != value)
    {
      domain = '.'+host;
      document.cookie = name+"="+value+expires+"; path=/; domain="+domain;
    }
  }
}

function getCookie(name) {
  var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)")
  if (arr = document.cookie.match(reg))
    return unescape(arr[2])
  else
    return null
}

function delCookie(name) {
  var exp = new Date();
  exp.setTime(exp.getTime() - 1);
  var cval = getCookie(name);
  if (cval != null)
    document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString();
}

